const BASE_URL = process.env.REACT_APP_BASE_URL

const getToken = (): string => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    return token
}

type ResponseTypes = {
    message: string;
    httpStatus: string;
    data?: any;
    errorCode?: number;
    errorMessage?: number;
    access_token?: string
}

export type APIResponseWarningLocation = {
    geoId: string;
    warningType: string;
    name: string;
    endDate: string;
    startDate: string;
    severity: string;
    msgEn: string;
    msgSi: string;
    msgDv: string;
    msgTa: string;
    status: string;
    warningId: string;
    latitude: number;
    longitude: number;
}

export const getValidWarningLocations = async (): Promise<{status: boolean, data: APIResponseWarningLocation[], message: string}> => {
    const URL: string = `${BASE_URL}/ew/api/v1/get_ew_locations`

    const HEADER = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`
        }
    }

    try
    {
        const response = await fetch(URL, HEADER)
        const responseData = await response.json()
        const apiResponse = responseData as ResponseTypes

        return {status: apiResponse.httpStatus === 'OK' ? true : false, data: apiResponse.data, message: apiResponse.message}
    }
    catch (error: any)
    {
        console.log("error while getting active geo locations [ ", error, " ]")
        return {status: false, data: [], message: "failed the request"}
    }
}

export type ResponseActiveEWCount = {
    count: number;
}

export const APIGetActiveEarlyWarningCount = async (): Promise<{ status: boolean; count: number; message: string; }> => {
    const URL: string = `${BASE_URL}/ew/api/v1/get_active_ew`;

    const HEADER = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`
        }
    }

    try
    {
        const response = await fetch(URL, HEADER)
        const responseJson = await response.json()
        const apiResponse = responseJson as ResponseTypes
        return {status: apiResponse.httpStatus === "OK" ? true : false, count: apiResponse.data.count as number, message: apiResponse.message}
    }
    catch (error)
    {
        console.log("error while getting active early warning count [ ", error, " ]")
        return {status: false, count: 0, message: "failed the request"}
    }
}
